import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product discount badge.
 * This component listens for variant update events and updates the discount display accordingly.
 */
class ProductDiscount extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateDiscount);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateDiscount);
  }

  /**
   * Updates the discount badge.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDiscount = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDiscount = event.detail.data.html.querySelector('product-discount [ref="discountContainer"]');
    const currentDiscount = this.querySelector('[ref="discountContainer"]');

    if (!newDiscount || !currentDiscount) return;

    if (currentDiscount.innerHTML !== newDiscount.innerHTML) {
      currentDiscount.replaceWith(newDiscount);
    }
  };
}

if (!customElements.get('product-discount')) {
  customElements.define('product-discount', ProductDiscount);
}
